import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import type { ToolsEquipment } from '@indutrust/capability-model';
import { EnvironmentService } from '@indutrust/shared-env';
import { BaseApiClient } from '@indutrust/shared-model';

/**
 * API client for the `tools_equipments` sub-resource nested under a
 * factory capability —
 * `/factories/{factoryId}/capabilities/{capabilityId}/tools_equipments`.
 *
 * Call inherited CRUD methods with
 * `urlSegments: { factoryId: <fid>, capabilityId: <cid> }`.
 */
@Service()
export class ToolsEquipmentApiClient extends BaseApiClient<ToolsEquipment> {
  protected envService = inject(EnvironmentService);
  protected http = inject(HttpClient);

  protected template: Partial<ToolsEquipment> = {};

  get url(): string {
    return `${this.envService.getApiUrl()}/factories/{factoryId}/capabilities/{capabilityId}/tools_equipments`;
  }
}
